import { render, staticRenderFns } from "./InlineModalController.vue?vue&type=template&id=28db8508"
import script from "./InlineModalController.vue?vue&type=script&lang=js"
export * from "./InlineModalController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports